// src/components/Footer.jsx
import React from "react";

const Footer = () => {
  return (
    <footer className="bg-[#193356] text-white px-6 py-10 mt-12">
  <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8 text-sm">
    {/* Company Info */}
    <div>
      <h3 className="text-lg font-semibold mb-3">Aarsh Industries</h3>
      <p>
        A trusted name in PTMT bathroom fittings. Combining innovation, durability,
        and affordability to craft products that last.
      </p>
    </div>

    {/* Quick Links */}
    <div>
      <h3 className="text-lg font-semibold mb-3">Quick Links</h3>
      <ul className="space-y-2">
        <li><a href="/" className="hover:underline">Home</a></li>
        <li><a href="/about" className="hover:underline">About Us</a></li>
        <li><a href="/products/taps" className="hover:underline">Taps & Faucets</a></li>
        <li><a href="/products/accessories" className="hover:underline">Accessories</a></li>
        <li><a href="/contact" className="hover:underline">Contact</a></li>
      </ul>
    </div>

    {/* Product Categories */}
    <div>
      <h3 className="text-lg font-semibold mb-3">Manufacturing Unit</h3>
      <p>Insta Industrial Park, </p>
      <p>Ahmedabad, Gujarat,</p>
      <p>India</p>

    </div>

    {/* Contact Info */}
    <div>
      <h3 className="text-lg font-semibold mb-3">Contact</h3>
      <p>Email: <a href="mailto:info@aarshindustries.com" className="hover:underline">info@emric.co.in</a></p>
      
    </div>
  </div>

  <div className="border-t border-white/20 mt-8 pt-6 text-center text-xs text-white/80">
    © 2025 Aarsh Industries. All rights reserved.
  </div>
</footer>

  );
};

export default Footer;
